import { useSelector } from "react-redux";
import checkCircleSuccess from "../../../assets/images/check_circle_success.svg";
import useLanguageTranslate from "../../../hooks/useLanguageTranslate";
import useSummary from "../../../hooks/useSummary";
import { selectNewMotorForm } from "../../../redux/features/newMotorFormSlice";
import { getPromoCodeLoading } from "../../../redux/features/promoCode/promoCodeSlice";
import Button from "../../common/Button/Button";
import Input from "../../common/Input/Input";
import { PROMO_CODE } from "./viewSummaryPopup";

const PromoCode = ({
  promoCode,
  setPromoCode,
  applyPromoCode,
  clearPromoCode,
  isDisabled = false,
  promoCodeApplied = false,
  isLoading = false, // External loading state (for travel/home/etc)
}) => {
  const {
    promocode,
    discount_percent,
    total_amount,
    premium,
    discount,
    discount_percentage,
    vat_additional_amount,
  } = useSummary();
  console.log(promocode + "promocode");
  console.log(promoCode + "promoCode");
  const translate = useLanguageTranslate();
  const isPromoCodeLoading = useSelector(getPromoCodeLoading);
  const promoCodeDetails = useSelector(selectNewMotorForm)?.[PROMO_CODE];

  return (
    <div className="bg-[#FDE9D2] rounded-[10px] items-center gap-2.5 self-stretch p-4 mb-4">
      <div className="flex apply-input gap-3 min-h-[75px] justify-between max767:gap-2">
        <Input
          label={translate("Promo Code", "رمز الخصم")}
          type="text"
          name="promoCode"
          className={`text-base not-italic font-normal leading-[26px] tracking-[-0.16px] mb-0 ${
            promoCodeApplied
              ? "!border-[#147A15] !text-[#4CA561]"
              : "text-[#48535B] placeholder:text-gray-300"
          }`}
          startAdornmentInputClassName={promoCodeApplied ? "startAdornmentIconSmall" : ""}
          value={promoCode}
          placeHolder={translate("PROMO CODE", "رمز الخصم")}
          data-testid="promoCode"
          handleChange={(e) => !promoCodeApplied && setPromoCode(e.target.value.toUpperCase())}
          inputClassName="!mb-0"
          readOnly={promoCodeApplied}
          startAdornment={
            promoCodeApplied ? (
              <img src={checkCircleSuccess} alt="" className="w-5 h-5" />
            ) : null
          }
        />

        <Button
          isLoading={isPromoCodeLoading || isLoading}
          label={promoCodeApplied ? translate("Remove", "إزالة") : translate("Apply", "تطبيق")}
          onSubmit={promoCodeApplied ? clearPromoCode : applyPromoCode}
          className={`rounded px-4 py-2 w-full !w-[86px] disabled:!bg-[#55C6EF50] disabled:text-opacity-50 ${
            promoCodeApplied
              ? "!bg-white hover:!bg-white border !border-[#DDE2E4]"
              : "bg-blue-500 text-white"
          }`}
          disabled={!promoCodeApplied && (!promoCode || isLoading)}
        />
      </div>
      {(promoCodeDetails?.promoCodeApplied == true || promoCodeApplied) &&
      promoCode ? (
        <div
          className="text-[#7C4A0F] not-italic font-normal leading-4 mt-2"
          style={{ fontSize: "12px" }}
        >
          <span>{translate("Promo code applied", "تم تطبيق كود الخصم")}.</span>
          {/* <span className="font-semibold">{` (${promoCode}) 10% off`}</span> */}
        </div>
      ) : null}
    </div>
  );
};

export default PromoCode;
